<template>
    <performance-common-dialog
        :title="'取消到车登记页面'"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'1300px'"
    >
        <template #top>
            <el-form
                class="form-container"
                ref="formRef"
                label-position="right"
                :model="config.form"
                label-width="100px"
            >
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="分公司名称：" prop="companyName">
                            <span>{{ componentsData.companyName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="平台名称：" prop="siteName">
                            <span>{{ componentsData.siteName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="发车单号：" prop="dispatchNo">
                            <span>{{ componentsData.dispatchNo }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="承运商名称：" prop="carrierName">
                            <span>{{ componentsData.carrierName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="实际车牌号：" prop="vehicleCard">
                            <span>{{ componentsData.vehicleCard }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="实际车型名称："
                            prop="equipmentName"
                        >
                            <span>{{ componentsData.equipmentName }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="司机名称：" prop="driver">
                            <span>{{ componentsData.driver }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="司机联系方式："
                            prop="driverContactWay"
                        >
                            <span>{{ componentsData.driverContactWay }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <template #table-list>
            <dispatch-cancel-arrTable
                :dispatchNo="componentsData.dispatchNo"
                :dictData="componentsData.dictData"
                :id="componentsData.id"
            ></dispatch-cancel-arrTable>
        </template>
    </performance-common-dialog>
</template>
<script>

import config from './config.js';
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import DispatchCancelArrTable from './DispatchCancelArrTable';
import {
    getDispatchInfo
}
    from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';

export default {
    name: 'dispatchArrivalRegistration',
    components: { PerformanceCommonDialog, DispatchCancelArrTable },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            dispatchInfo: {}
        };
    },
    methods: {
        dialogClose () {
            this.$emit('components-close');
        },
        /**
         *@description 使用发车单号查询发车单信息
         *@dispatchNo 入参，发车单号
        */
        getDispatchInfo () {
            getDispatchInfo(this.componentsData.dispatchNo).then(res => {
                if (res && +res.code === 0) {
                    this.dispatchInfo = res.data;
                }
            });
        }

    },
    mounted () {
        this.$refs.performanceCommonDialog.show();
        this.getDispatchInfo();
    }

};
</script>

<style scoped lang="less">
/deep/.el-form-item {
    margin: 0;
    .el-form-item__label {
        padding: 0;
    }
}
/deep/.el-tabs__header {
    margin-bottom: 0px;
}
/deep/.el-form-item__label {
    color: #999;
}
/deep/.el-form-item__content {
    color: #333;
}
.tms-performance-dialog .main-list-info {
    margin-top: 0px;
    padding-top: 0px;
}
</style>
